import tracking, { updateTracking } from './tracking';
import { AppWindow } from '../../definitions/AppWindow';

declare let window: AppWindow;

export function initTracking() {
  window.addEventListener('DOMContentLoaded', () => {
    tracking({ visualTracking: window.cwContext.visualTracking });
    window.cwtUpdateTracking = updateTracking;
  });
}
